// Override Settings
const boostPFSFilterConfig = {
  general: {
    limit: 50,
    /* Optional */
    loadProductFirst: false,
    // Placeholder
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    placeholderProductGridItemClass: 'collection__item grid__item medium--6 large--4',
    enableOTP: true,
    filterTreeMobileStyle: 'style1' // 'style2', 'style3',
  }
}

// Storing SVG variables
const svgGlasses = `<svg class="icon-glasses" width="44" height="13" viewBox="0 0 44 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M40.8751 3.38911H36.5911L36.3895 3.03502C35.2302 1.16342 33.1134 0 30.8958 0C28.7789 0 26.8637 1.01167 25.6037 2.73152L25.3013 3.18677L24.7973 2.93385C23.89 2.52918 22.9828 2.32685 21.9748 2.32685C20.866 2.32685 19.9084 2.57977 19.1019 3.03502L18.4971 3.33852L18.1443 2.83268C16.8843 1.11284 14.9187 0.101167 12.8018 0.101167C10.5338 0.101167 8.46735 1.26459 7.30813 3.18677L7.10653 3.49027H3.02406C1.36082 3.49027 0 4.85603 0 6.52529C0 8.19455 1.36082 9.56031 3.02406 9.56031C3.42726 9.56031 3.72967 9.25681 3.72967 8.85214C3.72967 8.44747 3.42726 8.19455 3.02406 8.19455C2.06644 8.19455 1.26002 7.38521 1.26002 6.42412C1.26002 5.46304 2.06644 4.6537 3.02406 4.6537H6.50172L6.30011 5.66537C6.30011 5.79183 6.28751 5.91829 6.27491 6.04475L6.27491 6.04476C6.26231 6.17122 6.24971 6.29767 6.24971 6.42412C6.24971 10.0661 9.17297 13 12.7514 13C16.3803 13 19.3036 10.0661 19.3036 6.42412C19.3036 5.91829 19.2027 5.31128 19.1019 4.75486L19.0515 4.24903L19.5052 4.04669C20.2612 3.64202 21.0676 3.49027 21.874 3.49027C22.6804 3.49027 23.4868 3.69261 24.1924 3.99611L24.6964 4.24903L24.5452 4.80545C24.4444 5.21012 24.394 5.76654 24.394 6.42412C24.394 10.0661 27.3173 13 30.9462 13C34.575 13 37.4983 10.0661 37.4983 6.42412C37.4983 6.07004 37.4479 5.66537 37.3975 5.36187L37.2967 4.60311H40.9759C41.9336 4.60311 42.6896 5.36187 42.6896 6.37354C42.6896 7.33463 41.8832 8.14397 40.9759 8.14397C40.5727 8.14397 40.2703 8.44747 40.2703 8.80156C40.2703 9.20623 40.5727 9.50973 40.9759 9.50973C42.6392 9.50973 44 8.14397 44 6.47471C43.8992 4.70428 42.5888 3.38911 40.8751 3.38911ZM36.0367 6.57588C36.0367 9.45914 33.7182 11.786 30.8454 11.786C27.9725 11.786 25.6541 9.45914 25.6541 6.57588C25.6541 3.74319 28.0229 1.31518 30.8454 1.31518C33.6678 1.31518 36.0367 3.74319 36.0367 6.57588ZM12.7514 11.786C15.6243 11.786 17.9931 9.45914 17.9931 6.57588C17.9931 3.69261 15.6243 1.31518 12.7514 1.31518C9.92898 1.31518 7.50974 3.74319 7.50974 6.57588C7.50974 9.45914 9.87858 11.786 12.7514 11.786Z" fill="black"></path>
  </svg>`
const svgHeart = `<svg class="icon-heart" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3652 2.67162C16.0077 2.30892 15.5832 2.02121 15.116 1.8249C14.6488 1.6286 14.1481 1.52757 13.6423 1.52757C13.1367 1.52757 12.636 1.6286 12.1688 1.8249L11.5921 0.413683C12.2421 0.140571 12.9387 0 13.6423 0C14.3459 0 15.0427 0.140571 15.6926 0.413683C16.3426 0.686793 16.9332 1.08709 17.4306 1.59172C17.9281 2.09604 18.3227 2.69482 18.5921 3.35383C18.8614 4.01296 19 4.71944 19 5.43291C19 6.14638 18.8614 6.85286 18.5921 7.51199C18.3227 8.17113 17.9279 8.76998 17.4303 9.27437L10.0324 16.7763C9.73825 17.0746 9.26132 17.0746 8.96718 16.7763L1.56908 9.27423C0.564411 8.25546 0 6.87369 0 5.43291C0 3.99213 0.564411 2.61037 1.56908 1.59158C2.57375 0.572805 3.93636 0.000454198 5.35717 0.000454198C6.77798 0.000454198 8.1406 0.572805 9.14526 1.59158L9.49978 1.95107L9.85414 1.59172C10.3516 1.08715 10.9422 0.686772 11.5921 0.413683L12.1688 1.8249C11.7017 2.02117 11.2771 2.30896 10.9196 2.67165L10.565 3.03124C9.97666 3.62778 9.02287 3.62778 8.43459 3.03123L8.08007 2.67174C7.35791 1.93943 6.37846 1.52803 5.35717 1.52803C4.33589 1.52803 3.35642 1.93943 2.63427 2.67174C1.91211 3.40405 1.5064 4.39727 1.5064 5.43291C1.5064 6.46856 1.91211 7.46177 2.63427 8.19408L9.49978 15.156L16.3651 8.19421C16.7228 7.83169 17.0068 7.401 17.2004 6.92726C17.394 6.4535 17.4936 5.94572 17.4936 5.43291C17.4936 4.92011 17.394 4.41232 17.2004 3.93857C17.0068 3.4649 16.7227 3.0341 16.3652 2.67162Z" fill="white"></path>
  </svg>`
const svgHeartFilled = `<svg class="icon-heart-filled" width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.6423 0C12.9387 0 12.2421 0.140571 11.5921 0.413683C10.9422 0.686772 10.3516 1.08715 9.85414 1.59172L9.49978 1.95107L9.14526 1.59158C8.1406 0.572805 6.77798 0.000454198 5.35717 0.000454198C3.93636 0.000454198 2.57375 0.572805 1.56908 1.59158C0.564411 2.61037 0 3.99213 0 5.43291C0 6.87369 0.564411 8.25546 1.56908 9.27423L8.96718 16.7763C9.26132 17.0746 9.73825 17.0746 10.0324 16.7763L17.4303 9.27437C17.9279 8.76998 18.3227 8.17113 18.5921 7.51199C18.8614 6.85286 19 6.14638 19 5.43291C19 4.71944 18.8614 4.01296 18.5921 3.35383C18.3227 2.69482 17.9281 2.09604 17.4306 1.59172C16.9332 1.08709 16.3426 0.686793 15.6926 0.413683C15.0427 0.140571 14.3459 0 13.6423 0Z" fill="white"></path>
  </svg>`
const chevronRight = `<svg class="icon-chevron-right" width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.3002 0L0.700195 0.7L10.8002 10.4L11.3049 10.9062L10.8002 11.4L0.700195 21L1.3002 21.7L12.7002 10.9L1.3002 0Z" fill="black"></path>
  </svg>`
const chevronLeft = `<svg class="icon-chevron-left" width="13" height="22" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.1002 21.7L12.7002 21L2.60019 11.3L2.09551 10.7937L2.60019 10.3L12.7002 0.699951L12.1002 -4.95911e-05L0.700195 10.8L12.1002 21.7Z" fill="black"></path>
  </svg>`
const arrowLeft = `<svg class="icon-small-arrow-left" width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.4 0.383999C3.904 1.408 3.44 2.176 3.008 2.688L17 2.688L17 3.696L3.008 3.696C3.44 4.208 3.904 4.976 4.4 6L3.56 6C2.552 4.832 1.496 3.968 0.392 3.408L0.392 2.976C1.496 2.432 2.552 1.568 3.56 0.383999L4.4 0.383999Z" fill="white"></path>
  </svg>`
const arrowRight = `<svg class="icon-small-arrow-right" width="17" height="6" viewBox="0 0 17 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.6 5.616C13.096 4.592 13.56 3.824 13.992 3.312H0V2.304H13.992C13.56 1.792 13.096 1.024 12.6 0H13.44C14.448 1.168 15.504 2.032 16.608 2.592V3.024C15.504 3.568 14.448 4.432 13.44 5.616H12.6Z" fill="white"></path>
  </svg>`
const chevronLeftSmall = `<svg class="icon-chevron-left" width="10" height="20" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.1002 21.7L12.7002 21L2.60019 11.3L2.09551 10.7937L2.60019 10.3L12.7002 0.699951L12.1002 -4.95911e-05L0.700195 10.8L12.1002 21.7Z" fill="black"></path>
  </svg>`
const chevronRightSmall = `<svg class="icon-chevron-right" width="10" height="20" viewBox="0 0 13 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.3002 0L0.700195 0.7L10.8002 10.4L11.3049 10.9062L10.8002 11.4L0.700195 21L1.3002 21.7L12.7002 10.9L1.3002 0Z" fill="black"></path>
  </svg>`

// Declare Templates
const boostPFSTemplate = {
  soldOutClass: 'sold-out',
  saleClass: 'on-sale',
  soldOutLabelHtml: '<div>' + boostPFSThemeConfig.label.sold_out + '</div>',
  saleLabelHtml: '<div>' + boostPFSThemeConfig.label.sale + '</div>',
  vendorHtml: '<div>{{itemVendorLabel}}</div>',

  // Grid Template
  productGridItemHtml: `<div class="grid__item wide--one-fifth large--one-quarter medium-down--one-half">
                              <div class="{{soldOutClass}} {{saleClass}}">
                                  <a href="{{itemUrl}}" class="grid-link">
                                      <span class="grid-link__image {{imageSoldOutClass}} grid-link__image--product">
                                          {{itemSaleLabel}}
                                          {{itemSoldOutLabel}}
                                          <span class="grid-link__image-centered"><img src="{{imageUrl}}" alt="{{itemTitle}}" /></span>
                                      </span>
                                      <p class="grid-link__title">{{itemTitle}}</p>
                                      {{itemVendor}}
                                      {{itemPrice}}
                                  </a>
                              </div>
                          </div>`,

  // Pagination Template
  previousActiveHtml: '<li><a href="{{itemUrl}}">&larr;</a></li>',
  previousDisabledHtml: '<li class="disabled"><span>&larr;</span></li>',
  nextActiveHtml: '<li><a href="{{itemUrl}}">&rarr;</a></li>',
  nextDisabledHtml: '<li class="disabled"><span>&rarr;</span></li>',
  pageItemHtml: '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
  pageItemSelectedHtml: '<li><span class="active">{{itemTitle}}</span></li>',
  pageItemRemainHtml: '<li><span>{{itemTitle}}</span></li>',
  paginateHtml: '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',

  // Sorting Template
  sortingHtml: '<label class="label--hidden">' + boostPFSThemeConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>'
};

(function () {
  BoostPFS.inject(this)

  /** ************************ BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data, index) {
    if (!data) data = this.data
    if (!index) index = this.index
    /** * Prepare data ***/
    const images = data.images_info
    // Displaying price base on the policy of Shopify, have to multiple by 100
    const soldOut = !data.available // Check a product is out of stock
    let onSale = data.compare_at_price_min > data.price_min // Check a product is on sale
    const priceVaries = data.price_min != data.price_max // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    let firstVariant = data.variants[0]
      	const firstVariantFix = data.variants[0]
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      const paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant')
      })
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]
    } else {
      for (let i = 0; i < data.variants.length; i++) {
        if (data.variants[i].available) {
          firstVariant = data.variants[i]
          break
        }
      }
    }
    if (isNaN(firstVariantFix.compare_at_price)) {
          	onSale = false
    }
    /** * End Prepare data ***/

    // Product URL
    const productURL = Weglot.getCurrentLang() === 'fr' ? `/fr/produits/${data.handle}` : `/products/${data.handle}`

    // Product Badge
    let productBadgeText
    let productBadgeClass
    let productBadgeColor
    let productBadgeFontColor

    if (soldOut) {
      productBadgeClass = 'soldout'
      productBadgeText = boostPFSThemeConfig.label.sold_out
    } else if (window.displayCustomLabels == 'true' && data.tags.includes(window.customLabel1.split('||')[0]) || data.tags.includes(window.customLabel2.split('||')[0]) || data.tags.includes(window.customLabel3.split('||')[0])) {
      let productCustomBadge = ''

      if (window.customLabel1.trim() != '' && data.tags.includes(window.customLabel1.split('||')[0])) {
        productCustomBadge = window.customLabel1.split('||')

        if (data.tags.includes(productCustomBadge[0])) {
          productBadgeText = productCustomBadge[1]
          productBadgeColor = productCustomBadge[2]
          productBadgeFontColor = productCustomBadge[3]
          productBadgeClass = 'custom'
        }
      } else if (window.customLabel2.trim() != '' && data.tags.includes(window.customLabel2.split('||')[0])) {
        productCustomBadge = window.customLabel2.split('||')

        if (data.tags.includes(productCustomBadge[0])) {
          productBadgeText = productCustomBadge[1]
          productBadgeColor = productCustomBadge[2]
          productBadgeFontColor = productCustomBadge[3]
          productBadgeClass = 'custom'
        }
      } else if (window.customLabel3.trim() != '' && data.tags.includes(window.customLabel3.split('||')[0])) {
        productCustomBadge = window.customLabel3.split('||')

        if (data.tags.includes(productCustomBadge[0])) {
          productBadgeText = productCustomBadge[1]
          productBadgeColor = productCustomBadge[2]
          productBadgeFontColor = productCustomBadge[3]
          productBadgeClass = 'custom'
        }
      }
    } else if (data.tags.includes('badge--web-sale')) {
      productBadgeClass = 'web-sale'
      productBadgeText = boostPFSThemeConfig.custom.web_sale
    } else if (data.tags.includes('badge--final-sale')) {
      productBadgeClass = 'final-sale'
      productBadgeText = boostPFSThemeConfig.custom.final_sale
    } else if (data.tags.includes('badge--new')) {
      productBadgeClass = 'new'
      productBadgeText = boostPFSThemeConfig.custom.new_product
    } else if (data.tags.includes('badge--pre-order')) {
      productBadgeClass = 'preorder'
      productBadgeText = boostPFSThemeConfig.custom.preorder
    } else if (data.tags.includes('badge--outlet')) {
      productBadgeClass = 'outlet'
      productBadgeText = boostPFSThemeConfig.custom.outlet
    } else if (onSale) {
      productBadgeClass = 'sale'
      productBadgeText = boostPFSThemeConfig.label.sale

      if (boostPFSThemeConfig.custom.display_sale_percentage || boostPFSThemeConfig.custom.display_sale_amount) {
        let discountTiers = null
        let discountTier = null

        if (boostPFSThemeConfig.custom.display_sale_percentage) {
          discountTiers = boostPFSThemeConfig.custom.percentage_discount_tiers
          discountTier = Math.round((1 - (data.price_min / data.compare_at_price_min)) * 100)
        } else if (boostPFSThemeConfig.custom.display_sale_amount) {
          discountTiers = boostPFSThemeConfig.custom.amount_discount_tiers
          discountTier = data.compare_at_price_min - data.price_min
        }

        discountTiers = discountTiers.replace(/\n/g, '').split('<br />')

        for (let i = 0; i < discountTiers.length; i++) {
          const tier = discountTiers[i]
          const tierArray = tier.split('|')
          if (i + 1 < discountTiers.length) {
            const nextTier = discountTiers[i + 1]
            const nextTierArray = nextTier.split('|')
            if (discountTier >= parseInt(tierArray[0], 10) && discountTier < parseInt(nextTierArray[0], 10)) {
              productBadgeColor = tierArray[1]
              productBadgeText = tierArray[2]
              break
            }
          } else {
            productBadgeColor = tierArray[1]
            productBadgeText = tierArray[2]
            break
          }
        }
      }
    }

    const wishlistAttr = (document.querySelector('[data-collection-customer]') === null) ? 'data-modal-trigger="wishlist-add-product-modal" aria-label="Open model"' : `data-product-id="${data.id}" data-variant-id="${firstVariant.id}" data-add-to-wishlist`
    const sunglassesAttr = (data.product_type === 'Sunglasses') ? 'data-sunglasses' : ''
    const productBadgeHTML = (productBadgeText !== undefined && productBadgeClass !== undefined) ? `<div class="collection__item-badge collection__item-badge--${productBadgeClass}" ${productBadgeColor ? `style="background-color: ${productBadgeColor}"` : ''}><span ${productBadgeFontColor ? `style="color: ${productBadgeFontColor}"` : ''}>${productBadgeText}</span></div>` : ''

    // Product Try on
    const productTryonHTML = (data.tags.includes('badge--try-on')) ? `<div class="collection__item-try-on">${svgGlasses}<span>${boostPFSThemeConfig.custom.try_on}</span></div>` : ''

    // Product material
    let materialTag = data.tags.find((tag) => tag.includes('material--'))?.split('--').pop()
    if (materialTag !== null) {
      materialTag = materialTag?.replace(' ', '_')?.replace('-', '_').toLowerCase()
    }
    const material = boostPFSThemeConfig.custom[materialTag] ?? materialTag ?? ""

    // Product shape
    let shapeTag = data.tags.find((tag) => tag.includes('shape--'))?.split('--')?.pop()?.toLowerCase()

    if (shapeTag !== null) {
      shapeTag = shapeTag?.replace(' ', '_')
    }
    const shape = (boostPFSThemeConfig.custom[shapeTag] ?? shapeTag)?.toLowerCase() ?? ""

    // Product Price
    const productPrice = Utils.formatMoney(firstVariantFix.price)
    let productPriceHTML = (onSale) ? `<s>${Utils.formatMoney(firstVariantFix.compare_at_price)}</s><span>${productPrice}</span>` : productPrice

    // console.log(Weglot.getCurrentLang())
    //   if Weglot.getCurrentLang() == 'fr'{
    //   	const = productPriceHTML = (onSale) ? `<span>${productPrice}</span> <s>${Utils.formatMoney(firstVariant.compare_at_price)}</s>` : productPrice;
    //   }
    //   else
    //   {
    //   	const = productPriceHTML = (onSale) ? `<s>${Utils.formatMoney(firstVariant.compare_at_price)}</s><span>${productPrice}</span>` : productPrice;
    //   }
    // Product Image
    let productImageSrc = images.length > 0 ? Utils.optimizeImage(images[0].src, '1200x') : boostPFSAppConfig.general.no_image_url

    // Product Swatches
    const colorOptionIndex = data.options.indexOf('colour') || data.options.indexOf('color') ? 0 : -1
    let swatchWrapperHTML = ''
    let swatchHTML = ''
    const productVariants = []

    data.variants.forEach((variant) => {
      const variantData = {
        variant_id: `${variant.id}`,
        variant_color: `${variant.option1}`
      }
      productVariants.push(variantData)
    })

    if (boostPFSConfig.general.template != 'collection.no-swatches' && colorOptionIndex > -1) {
      data.options_with_values[colorOptionIndex].values.forEach((swatch, index) => {
        const isActive = (index === 0) ? 'active' : ''
        const swatchVariantImage = (swatch.image !== null) ? data.images[swatch.image] : boostPFSAppConfig.general.no_image_url
        const swatchVariantHandle = swatch.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
        let variantId = null
        let firstVariant = true
        let variantPrice = null
        let variantCPrice = null

        if (index === 0) {
          productImageSrc = swatchVariantImage
        }

        data.variants.forEach((variant) => {
          if (variant.option1 !== swatch.title) { return }

          if (firstVariant === true) {
            variantId = variant.id
            variantPrice = variant.price
            variantCPrice = variant.compare_at_price
            firstVariant = false
          }
        })

        const swatchButtonHTML = `<button class="collection__item-swatch collection__item-swatch--${swatchVariantHandle} ${isActive}" aria-label="${swatch.title} Color Swatch" data-value="${swatch.title}" style="background-image: url(${window.theme.fileUrl}${Utils.slugify(swatch.title)}.jpg)"; data-variant-image="${swatchVariantImage}" data-variant-url="${productURL}/${swatchVariantHandle}" data-variant-id="${variantId}" data-variant-price="${variantPrice}" data-product-price="${variantCPrice}" data-collection-item-swatch></button>`

        swatchHTML += (data.options_with_values[colorOptionIndex].values.length >= 7) ? `<div class="swiper-slide">${swatchButtonHTML}</div>` : swatchButtonHTML
      })

      swatchWrapperHTML = (data.options_with_values[colorOptionIndex].values.length >= 7)
        ? `<div class="collection__item-swatches" role="region" aria-label="${data.title} Color Swatches" data-collection-item-swatch-wrapper>
            <div class="swiper-controls">
              <button class="swiper-button-prev swiper-button-prev--${data.handle}" aria-label="Previous Swatch">${chevronLeft}</button>
              <button class="swiper-button-next swiper-button-next--${data.handle}" aria-label="Next Swatch">${chevronRight}</button>
            </div>

            <div class="swiper" data-product-handle="${data.handle}" data-collection-item-swatch-carousel>
              <div class="swiper-wrapper">
                ${swatchHTML}
              </div>
            </div>
          </div>`
        : `<div class="collection__item-swatches" role="region" aria-label="${data.title} Color Swatches" data-collection-item-swatch-wrapper>${swatchHTML}</div>`
    }

    const weglotClass = (data.product_type === 'Accessory' || data.product_type === 'Gift Card') ? '' : 'weglot-exclude'

    let collectionItem = ''
    if (boostPFSConfig.general.template != 'collection.no-swatches') {
      collectionItem = `<div data-product-handle="${data.handle}" class="collection__item collection__item--bc collection__item--${data.handle} grid__item medium--6 large--4 {{alignment}}" data-collection-item>
                            <div class="collection__item-image-wrapper">
                              <a class="image-link" href="${productURL}" title="${data.title} - ${productPrice}" aria-label="${data.title} - ${productPrice}">
                                <div class="responsive-image__wrapper">
                                  <img class="responsive-image__image" src="${productImageSrc}" alt="${data.title}" data-collection-item-image>
                                </div>
                              </a>
                              <div class="collection__item-badge--wrapper">${productBadgeHTML}</div>
                              ${swatchWrapperHTML}
                            </div>

                            <div class="collection__item-content">
                            <div class="collection__item-content-column">
                              <h4 class="${weglotClass}">
                                <a href="${productURL}" title="${data.title} - ${productPrice}" aria-label="${data.title} - ${productPrice}">${data.title}</a>
                              </h4>
                              <p class="material_shape">${material} ${shape}</p>
                            </div>
                              
                              <p class="boost-pfs-price">${productPriceHTML}</p>
                            </div>
                        </div>`
    } else {
      collectionItem = `<div class="collection__item collection__item--bc collection__item--${data.handle} grid__item medium--6 large--4 {{alignment}}" data-collection-item>
                                  <div class="collection__item-image-wrapper">
                                    <a class="image-link" href="${productURL}" title="${data.title} - ${productPrice}" aria-label="${data.title} - ${productPrice}">
                                      <div class="responsive-image__wrapper">
                                        <img class="responsive-image__image" src="${productImageSrc}" alt="${data.title}" data-collection-item-image>
                                      </div>
                                    </a>
                                    <div class="collection__item-badge--wrapper">${productBadgeHTML}</div>
                                    ${swatchWrapperHTML}
                                  </div>

                                  <div class="collection__item-content">
                                    <h4 class="${weglotClass}">
                                      <a href="${productURL}" title="${data.title} - ${productPrice}" aria-label="${data.title} - ${productPrice}">${data.title} <span style="font-size: 12px">+ ${data.options_with_values[colorOptionIndex].values.length} colors</span></a>
                                    </h4>

                                    <button class="collection__item-wishlist" aria-label="Add ${data.title} to Wishlist" data-product-variants='${JSON.stringify(productVariants)}' ${wishlistAttr} ${sunglassesAttr}>
                                      ${svgHeart}
                                      ${svgHeartFilled}
                                    </button>

                                    <p class="boost-pfs-price">${productPriceHTML}</p>
                                  </div>
                              </div>`
    }

    let gridItemHTML = collectionItem.replace('{{alignment}}', '')

    // Collection CTA
    let currentPageCycle = 'odd'
    if (window.location.search.length) {
      for (let keyValue, i = 0, pair = window.location.search.substr(1).split('&'); i < pair.length; i++) {
        keyValue = pair[i].split('=')
        if (keyValue.length > 1 && keyValue[0] === 'page') {
          currentPageCycle = ((parseInt(keyValue[1], 10) % 2) === 0) ? 'even' : 'odd'
        }
      }
    }

    const collectionCTA = Array.from(collectionItemMetafields.collectionItems).find((item) => parseInt(item.item_index, 10) === index && item.page_cycle === currentPageCycle)
    let collectionCTAHTML = ''

    if (collectionCTA !== undefined) {
      const collectionCTALeft = (collectionCTA.alignment === 'Left')
      collectionCTAHTML = `<div class="small--hide grid__item large--8">
              <div class="collection__cta" role="region" aria-label="Collection Call to Action" style="background-color: ${collectionCTA.background_color};" data-collection-cta-number="${collectionCTA.cta_index}" data-collection-cta>
                <div class="collection__cta-column medium-up--hide">
                  <img src="${collectionCTA.mobile_image}" alt="${collectionCTA.headline} Image">
                </div>

                <div class="collection__cta-column">
                  <div class="collection__cta-content">
                    <div class="display-table">
                      <div class="display-table-cell">
                        <h3>${collectionCTA.headline}</h3>
                        <p>${collectionCTA.subline}</p>
                        <a class="btn btn--outline" href="${collectionCTA.button_url}" title="${collectionCTA.button_text}">${collectionCTA.button_text}</a>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="collection__cta-column small--hide">
                  <div class="collection__cta-image" style="background-image: url(${collectionCTA.desktop_image});"></div>
                </div>
              </div>
            </div>`

      gridItemHTML = (collectionCTALeft) ? `${collectionItem.replace('{{alignment}}', 'large--hide')}${collectionCTAHTML}${collectionItem.replace('{{alignment}}', 'medium-down--hide')}` : `${collectionItem.replace('{{alignment}}', '')}${collectionCTAHTML}`
    }

    return gridItemHTML

    // Add main attribute (Always put at the end of this function)
    // 		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    // 		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    // 		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    // 		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    // 		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));
    // 		return itemHtml;
  }

  /** ************************ END BUILD PRODUCT LIST **************************/
  /** ************************ BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildReview (data) {
    let html = ''
    if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true) {
      html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>'
    }
    return html
  }

  /** ************************ END BUILD PRODUCT ITEM ELEMENTS **************************/
  /** ************************ BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    if (!totalProduct) totalProduct = this.totalProduct
    // Get page info
    const currentPage = parseInt(Globals.queryParams.page)
    const totalPage = Math.ceil(totalProduct / Globals.queryParams.limit)
    const currentTotalProduct = (Globals.queryParams.page === totalPage) ? totalProduct - (Globals.queryParams.limit * (totalPage - 1)) : Globals.queryParams.limit

    // If it has only one page, clear pagination
    if (totalPage <= 1) {
      return ''
    }

    // Build prev
    let previousHTML = ''
    if (currentPage > 1) {
      previousHTML = `
        <span class="prev">
          <a href="${Utils.buildToolbarLink('page', currentPage, currentPage - 1)}" title="Go To Previous Page">
            <span aria-label="Go To Previous Page">
              <span class="small--hide">${boostPFSThemeConfig.custom.pagination_prev}</span>
              <span class="all--hide small--show circle-button-mobile">${chevronLeftSmall}</span>
            </span>
          </a>
        </span>`
    } else {
      previousHTML = `
        <span class="prev disabled">
          <span aria-label="Go To Previous Page">
            <span class="small--hide">${boostPFSThemeConfig.custom.pagination_prev}</span>
            <span class="all--hide small--show circle-button-mobile">${chevronLeftSmall}</span>
          </span>
        </span>
      `
    }

    // Build next
    let nextHTML = ''
    if (currentPage < totalPage) {
      nextHTML = `
        <span class="next">
          <a href="${Utils.buildToolbarLink('page', currentPage, currentPage + 1)}" title="Go To Next Page">
            <span aria-label="Go To Next Page">
              <span class="small--hide">${boostPFSThemeConfig.custom.pagination_next}</span>
              <span class="all--hide small--show circle-button-mobile">${chevronRightSmall}</span>
            </span>
          </a>
        </span>
      `
    } else {
      nextHTML = `
        <span class="next disabled">
          <span aria-label="Go To Next Page">
            <span class="small--hide">${boostPFSThemeConfig.custom.pagination_next}</span>
            <span class="all--hide small--show circle-button-mobile">${chevronRightSmall}</span>
          </span>
        </span>
      `
    }

    // Create page items array
    const mobilePagination = window.innerWidth <= 666
    const beforeCurrentPageArr = []
    const afterCurrentPageArr = []
    if (mobilePagination) {
      if (currentPage == totalPage) {
        beforeCurrentPageArr.unshift(1)
        beforeCurrentPageArr.push('...')
        afterCurrentPageArr.unshift(totalPage)
      } else if (currentPage < totalPage) {
        beforeCurrentPageArr.unshift(currentPage)
        afterCurrentPageArr.push('...')
        afterCurrentPageArr.push(totalPage)
      }
    } else {
      // Before pages
      for (let iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore)
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...')
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1)
      }
      beforeCurrentPageArr.push(currentPage)

      // After pages
      for (let iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter)
      }
      if ((currentPage + 3) < totalPage) {
        afterCurrentPageArr.push('...')
      }
      if ((currentPage + 3) <= totalPage) {
        afterCurrentPageArr.push(totalPage)
      }
    }
    // Build page items
    let pageItemsHTML = ''
    const pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr)
    for (let iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] === '...') {
        pageItemsHTML += '<span class="page infinite-dots">&hellip;</span>'
      } else {
        pageItemsHTML += (pageArr[iPage] === currentPage)
          ? `<span class="page current">${currentPage}</span>`
          : `<span class="page"><a href="${Utils.buildToolbarLink('page', currentPage, pageArr[iPage])}" title="Go To Page ${pageArr[iPage]}" aria-label="Go To Page ${pageArr[iPage]}">${pageArr[iPage]}</a></span>`
      }
    }

    const paginationHTML = `
      <div class="grid" style="display:flex;">
        <div class="grid__item medium-down--hide" style="width: auto;">
          <span class="collection__count collection__count--alt">
            ${boostPFSThemeConfig.custom.display_text} ${currentTotalProduct} ${boostPFSThemeConfig.custom.display_of_text} ${totalProduct} ${boostPFSThemeConfig.custom.display_collection_text}
          </span>
        </div>
        <div class="grid__item large--text-right" style="flex: 1;">
          <div class="pagination" aria-label="Pagination">
            ${previousHTML}
            ${pageItemsHTML}
            ${nextHTML}
          </div>
        </div>
      </div>
    `
    return paginationHTML
  }

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    let html = ''
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      const sortingArr = Utils.getSortingList()
      if (sortingArr) {
        const paramSort = Globals.queryParams.sort || ''
        // Build content
        let sortingItemsHtml = ''
        for (const k in sortingArr) {
                  	sortingItemsHtml += `<option value="${k}" data-sorting-filter-option-value="${k}">${sortingArr[k]}</option>`
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml)
      }
    }
    return html
  }

  // 	ProductSorting.prototype.render = function() {
  // 		jQ(Selector.topSorting).html(this.compileTemplate());

  // 		if (jQ('.boost-pfs-filter-custom-sorting').hasClass('boost-pfs-filter-sort-active')) {
  // 			jQ('.boost-pfs-filter-custom-sorting').toggleClass('boost-pfs-filter-sort-active');
  // 		}

  // 		var labelSort = '';
  // 		var paramSort = Globals.queryParams.sort || '';
  // 		var sortingList = Utils.getSortingList();
  // 		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
  // 			labelSort = sortingList[paramSort];
  // 		} else {
  // 			labelSort = Labels.sorting_heading;
  // 		}

  // 		jQ('.boost-pfs-filter-custom-sorting button span span').text(labelSort);
  // 	}

  // 	// Build Sorting event
  // 	ProductSorting.prototype.bindEvents = function() {
  // 		var _this = this;
  // 		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
  // 			e.preventDefault();
  // 			FilterApi.setParam('sort', jQ(this).data('sort'));
  // 			FilterApi.setParam('page', 1);
  // 			FilterApi.applyFilter('sort');
  // 		});

  // 		jQ(".boost-pfs-filter-custom-sorting > button").click(function() {
  // 			if (!jQ('.boost-pfs-filter-filter-dropdown').is(':animated')) {
  // 				jQ('.boost-pfs-filter-filter-dropdown').toggle().parent().toggleClass('boost-pfs-filter-sort-active');
  // 			}
  // 		});

  // 		jQ(Selector.filterTreeMobileButton).click(function() {
  // 			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
  // 		});

  // 		jQ(document).on('click', function (e) {
  //       if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
  //       	jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
  //       }
  //     });
  // 	};

  /** ************************ END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data

    // Intergrate Review Shopify
    if (window.SPR &&
			typeof window.SPR.initDomEls === 'function' &&
			typeof window.SPR.loadBadges === 'function' &&
			boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls()
      window.SPR.loadBadges()
    }
  }

  // Build additional elements
  Filter.prototype.afterRender = function (data) {
    if (!data) data = this.data

    const collectionItemSwatchCarousels = document.querySelectorAll('[data-collection-item-swatch-carousel]')
    collectionItemSwatchCarousels.forEach((collectionItemSwatchCarousel) => {
      const productHandle = collectionItemSwatchCarousel.getAttribute('data-product-handle')

      new window.swiper(collectionItemSwatchCarousel, {
        slidesPerView: 6,
        navigation: {
          nextEl: `.swiper-button-next--${productHandle}`,
          prevEl: `.swiper-button-prev--${productHandle}`
        }
      })
    })

    const mData = data
    jQ(document).on('click', '.collection__item-swatch', function () {
      const selectVariantPrice = jQ(this).data('variant-price')
      const selectVariantCPrice = jQ(this).data('product-price')
      if (selectVariantCPrice > selectVariantPrice) {
        jQ(this).closest('.collection__item').find('.boost-pfs-price s').show()
        jQ(this).closest('.collection__item').find('.boost-pfs-price s').html(Utils.formatMoney(selectVariantCPrice))
        jQ(this).closest('.collection__item').find('.boost-pfs-price span').html(Utils.formatMoney(selectVariantPrice))
      } else {
        jQ(this).closest('.collection__item').find('.boost-pfs-price s').hide()
        jQ(this).closest('.collection__item').find('.boost-pfs-price span').html(Utils.formatMoney(selectVariantPrice))
      }
    })
  }
})()
